import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReturnService {

  constructor(private http: HttpClient) { }
  
  url = environment.serverAPI5 + '/' + 'api/purchaseOrderReturn';

  searchPurchaseReturn(query: any, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getPurchaseReturn(Page: number, size: number, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllPurchaseReturnDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getPurchaseReturnById(purchaseReturnId: number): Observable<Object> {
    return this.http.get(`${this.url}/${purchaseReturnId}`);
  }

  createPurchaseReturn(purchaseReturn: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, purchaseReturn);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  downloadPurchaseReturnReport(Page: number, size: number, sort: any, selection: any): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}&size=${size}&sort=${sort}`, selection, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  downloadPurchaseReturnTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  deleteByPurchaseReturnId(purchaseReturnId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${purchaseReturnId}`);
  }

}
